import React, { useState } from "react"
import { Link } from "react-router-dom"
import Layout from "../components/layout/Layout"

export default function ArenasAcademies() {
	const [activeFilter, setActiveFilter] = useState("all")

	const locations = [
		{
			id: 1,
			name: "PROPLAY Sports & Eats",
			area: "Nagarbhavi",
			category: "arena",
			categoryLabel: "Sports Arena & Academy",
			desc: "Sports arena, academy and sporting destination.",
			features: ["Turf Grounds", "Academy Training", "Sports Cafe & Lounge", "Community Events"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
					<polyline points="9 22 9 12 15 12 15 22" />
				</svg>
			)
		},
		{
			id: 2,
			name: "PROPLAY Playpoint",
			area: "Peenya",
			category: "arena",
			categoryLabel: "Arena Operations",
			desc: "Arena operations and sporting programmes.",
			features: ["Multi-Sport Courts", "Competitive Leagues", "Corporate Tournaments", "Training Slots"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<circle cx="12" cy="12" r="10" />
					<polygon points="10 8 16 12 10 16 10 8" />
				</svg>
			)
		},
		{
			id: 3,
			name: "PROPLAY EL Club",
			area: "HSR",
			category: "arena",
			categoryLabel: "Arena & Academy",
			desc: "Arena and academy operations.",
			features: ["Football Turf", "Badminton & Box Cricket", "Youth Academies", "Coaching Modules"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
					<path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
					<path d="M4 22h16" />
					<path d="M10 14.66V17c0 .55-.45 1-1 1H7" />
					<path d="M14 14.66V17c0 .55.45 1 1 1h2" />
					<path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
				</svg>
			)
		},
		{
			id: 4,
			name: "PROPLAY Academy Joras",
			area: "JP Nagar",
			category: "academy",
			categoryLabel: "Academy & Coaching",
			desc: "Academy and coaching programmes.",
			features: ["Structured Curriculum", "Certified Coaches", "Age-Specific Batches", "Performance Tracking"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
				</svg>
			)
		},
		{
			id: 5,
			name: "PROPLAY Academy Nature Kicks",
			area: "Kanakapura Road",
			category: "academy",
			categoryLabel: "Sporting Programmes",
			desc: "Academy and sporting programmes.",
			features: ["Outdoor Pitches", "Grassroots Football", "Weekend Clinics", "Physical Conditioning"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<circle cx="12" cy="12" r="10" />
					<path d="m4.93 4.93 4.24 4.24M14.83 9.17l4.24-4.24M14.83 14.83l4.24 4.24M9.17 14.83l-4.24 4.24" />
				</svg>
			)
		},
		{
			id: 6,
			name: "PROPLAY Academy Sports",
			area: "RR Nagar",
			category: "academy",
			categoryLabel: "Multi-Sport Academy",
			desc: "Multi-sport academy programmes.",
			features: ["Multi-discipline Training", "Skill Development", "Competitive Exposure", "Expert Mentorship"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M22 12h-4l-3 9L9 3l-3 9H2" />
				</svg>
			)
		},
		{
			id: 7,
			name: "PROPLAY Academy — Nirma School Arena",
			area: "Nagarbhavi",
			category: "school",
			categoryLabel: "School & Academy",
			desc: "School and academy sporting programmes.",
			features: ["In-School Sport Integration", "After-School Academies", "Inter-School Cups", "Grassroots Pathways"],
			icon: (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M22 10v6M2 10l10-5 10 5-10 5z" />
					<path d="M6 12v5c3 3 9 3 12 0v-5" />
				</svg>
			)
		}
	]

	const filteredLocations = activeFilter === "all" 
		? locations 
		: locations.filter(loc => loc.category === activeFilter)

	return (
		<Layout headerStyle={1} footerStyle={1}>
			<div className="proplay-arenas-page">
				{/* 1. HERO BANNER */}
				<section 
					className="proplay-about-hero" 
					style={{ backgroundImage: `url('images/about/hero_sports_bg.png')` }}
				>
					<div className="proplay-hero-overlay" />
					<div className="themeflat-container position-relative z-index-2 py-5">
						<div className="row align-items-center">
							<div className="col-lg-9 col-md-11">
								<div className="proplay-accent-line wow fadeInUp" data-wow-delay="0.1s" />
								<h1 className="proplay-hero-title wow fadeInUp" data-wow-delay="0.2s">
									OUR ARENAS &amp; <br />
									<span className="proplay-cyan-gradient">ACADEMY LOCATIONS</span>
								</h1>
								<p className="proplay-hero-subtitle wow fadeInUp" data-wow-delay="0.3s">
									Connecting players, students, coaches, and communities across a rapidly expanding sporting ecosystem.
								</p>
							</div>
						</div>
					</div>
				</section>

				{/* 2. LOCATIONS LIST SECTION */}
				<section className="proplay-locations-section" id="network">
					<div className="themeflat-container">
						{/* Top Header */}
						<div className="text-center mb-4 wow fadeInUp" data-wow-delay="0.1s">
							<div className="proplay-section-badge">
								<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
									<circle cx="12" cy="10" r="3" />
								</svg>
							</div>
							<div className="proplay-title-lines">
								<div className="proplay-line" />
								<h2 className="proplay-section-title">
									EXPLORE <span className="proplay-cyan-gradient">OUR NETWORK</span>
								</h2>
								<div className="proplay-line" />
							</div>
							<p className="proplay-section-desc mt-3 wow fadeInUp" data-wow-delay="0.2s">
								PROPLAY currently operates and/or conducts sporting programmes across a growing network of locations, including:
							</p>

							{/* Filter Tabs */}
							<div className="d-flex justify-content-center flex-wrap gap-2 mt-4 wow fadeInUp" data-wow-delay="0.25s">
								<button 
									className={`btn btn-sm ${activeFilter === "all" ? "btn-info text-white" : "btn-outline-secondary text-light"}`}
									style={{ borderRadius: "20px", padding: "6px 18px", fontWeight: "600", fontSize: "13px" }}
									onClick={() => setActiveFilter("all")}
								>
									All Locations (7)
								</button>
								<button 
									className={`btn btn-sm ${activeFilter === "arena" ? "btn-info text-white" : "btn-outline-secondary text-light"}`}
									style={{ borderRadius: "20px", padding: "6px 18px", fontWeight: "600", fontSize: "13px" }}
									onClick={() => setActiveFilter("arena")}
								>
									Arenas &amp; Clubs (3)
								</button>
								<button 
									className={`btn btn-sm ${activeFilter === "academy" ? "btn-info text-white" : "btn-outline-secondary text-light"}`}
									style={{ borderRadius: "20px", padding: "6px 18px", fontWeight: "600", fontSize: "13px" }}
									onClick={() => setActiveFilter("academy")}
								>
									Academies &amp; Coaching (3)
								</button>
								<button 
									className={`btn btn-sm ${activeFilter === "school" ? "btn-info text-white" : "btn-outline-secondary text-light"}`}
									style={{ borderRadius: "20px", padding: "6px 18px", fontWeight: "600", fontSize: "13px" }}
									onClick={() => setActiveFilter("school")}
								>
									School Arenas (1)
								</button>
							</div>
						</div>

						{/* Locations Grid */}
						<div className="proplay-locations-grid">
							{filteredLocations.map((loc, idx) => (
								<div className="proplay-location-card wow fadeInUp" data-wow-delay={`${0.1 + idx * 0.05}s`} key={loc.id}>
									<div className="proplay-location-header">
										<div className="proplay-location-icon">
											{loc.icon}
										</div>
										<div className="proplay-location-title-wrap">
											<h3 className="proplay-location-name">{loc.name}</h3>
											<span className="proplay-location-area">
												<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
													<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
													<circle cx="12" cy="10" r="3" />
												</svg>
												{loc.area}
											</span>
										</div>
									</div>
									<p className="proplay-location-desc">
										{loc.desc}
									</p>
									<div className="proplay-founder-tags mt-3 mb-3">
										{loc.features.map((feat, fIdx) => (
											<span className="proplay-founder-tag" key={fIdx}>{feat}</span>
										))}
									</div>
									<div className="mt-auto pt-2">
										<a 
											href="https://book.proplay.zone/" 
											target="_blank" 
											rel="noreferrer" 
											className="proplay-btn-cyan w-100 justify-content-center"
											style={{ padding: "10px 16px", fontSize: "13px" }}
										>
											Book &amp; Play &rarr;
										</a>
									</div>
								</div>
							))}
						</div>

						{/* Ecosystem Connecting Callout */}
						<div className="proplay-locations-callout wow fadeInUp" data-wow-delay="0.4s">
							<div className="proplay-locations-callout-icon">
								<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<circle cx="12" cy="12" r="10" />
									<line x1="2" y1="12" x2="22" y2="12" />
									<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
								</svg>
							</div>
							<p className="proplay-locations-callout-text">
								As PROPLAY expands, this network will progressively connect arenas, academies, schools and communities through one sporting ecosystem.
							</p>
						</div>
					</div>
				</section>

				{/* 3. CTA SECTION */}
				<section 
					className="proplay-cta-section" 
					style={{ backgroundImage: `url('images/about/join_proplay_bg.png')` }}
				>
					<div className="proplay-cta-overlay" />
					<div className="themeflat-container position-relative z-index-2">
						<div className="row align-items-center">
							<div className="col-lg-8">
								<h2 className="proplay-cta-title wow fadeInUp" data-wow-delay="0.1s">
									Partner With <span className="proplay-cyan-gradient">PROPLAY.</span>
								</h2>
								<h3 className="proplay-cta-sub wow fadeInUp" data-wow-delay="0.2s">
									Bring your arena, academy, or school into our sporting network.
								</h3>
								<div className="d-flex flex-wrap gap-3 wow fadeInUp" data-wow-delay="0.3s">
									<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-btn-cyan">
										BOOK A SLOT &rarr;
									</a>
									<Link to="/contact" className="proplay-btn-outline">
										CONTACT OUR TEAM &rarr;
									</Link>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</Layout>
	)
}
